import React from 'react';

class LoginModal extends React.Component {

  componentDidUpdate() {
    if (this.props.loginRequired) {
      $(React.findDOMNode(this.refs.modal)).modal();
    }
  }
  
  render() {
    var next = location.pathname + escape(location.search);
    var  modalWidth = '450px';
    if (screen.width <= 480) {
      modalWidth = 'auto';
    }
    

    return (        
<div className="modal fade" id="loginModal" tabIndex="-1" role="dialog" aria-labelledby="loginModalLabel" ref="modal">
        <div className="modal-dialog ngdialog ngdialog-theme-default" role="document" style={{ width: modalWidth }}>
    <div className="modal-content ngdialog-content">
        <h1><i className="fa fa-user" style={{ marginRight: 10}}></i> Login </h1>
  <hr/>
  <div className="content">
    <p>Login to save your bookmarks.</p>
        {/*
          <p><a href={"/auth/facebook?state=" + next} className="btn facebook-login"> <i className="fa fa-facebook"></i>  Log in with Facebook </a></p>
        */}
        <p><a href={"/auth/gplus?state=" + next} className="btn gplus-login"> <i className="fa fa-google-plus"></i>  Log in with Google </a></p>
  </div>
        <div className="ngdialog-close" data-dismiss="modal"></div>
    </div>
  </div>
</div>
    );
  }
  
}

module.exports = LoginModal;



// WEBPACK FOOTER //
// ./components/login-modal.js